import React, { useEffect, useRef } from 'react';
import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';

import img1 from '../assets/drywall1.png';
import img2 from '../assets/SDS-Hex.png'
import img3 from '../assets/SDS-Flat.png'
import img4 from '../assets/SDS-Pan.png'
import img5 from '../assets/SDS-Wafer.png'
import img6 from '../assets/csk.png'
import img7 from '../assets/csk-slotted.png'
import img8 from '../assets/philips.png'
import img9 from '../assets/pan-philips.png'
import img10 from '../assets/pan.png'
import img11 from '../assets/allen2.png'
import img12 from '../assets/WoodScrew/WS2.png'
import img13 from '../assets/item6.png'
import img14 from '../assets/ss.png'
import img15 from '../assets/Concrete/CN2.png'

const imagePaths=[img1,img2,img3,img4,img5,img6,img7,img8,img9,img10,img11,img12,img13,img14,img15];

const ThreeSlider = () => {
    const mountRef = useRef(null);
  
    useEffect(() => {
      const width = mountRef.current.clientWidth;
      const height = mountRef.current.clientHeight;
  
      const scene = new THREE.Scene();
      const camera = new THREE.PerspectiveCamera(50, width / height, 0.1, 1000);
      camera.position.z = 35; // Pull camera back
  
      const renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
      renderer.setSize(width, height);
      mountRef.current.appendChild(renderer.domElement);
  
      const controls = new OrbitControls(camera, renderer.domElement);
      controls.enableZoom = false;
      controls.enableRotate = false;
      controls.enablePan = false;
  
      const textureLoader = new THREE.TextureLoader();
      const group = new THREE.Group();
      const radius = 18; // Spread images wider
      const imageWidth = 5;
      const imageHeight = 5;
  
      let loadedCount = 0;
      const totalImages = imagePaths.length;
  
      imagePaths.forEach((imgPath, i) => {
        textureLoader.load(imgPath, texture => {
          const geometry = new THREE.PlaneGeometry(imageWidth, imageHeight);
          const material = new THREE.MeshBasicMaterial({
            map: texture,
            transparent: true,
            side: THREE.FrontSide,
          });
  
          const mesh = new THREE.Mesh(geometry, material);
          const angle = (i / totalImages) * Math.PI * 2;
  
          mesh.position.set(
            Math.cos(angle) * radius,
            0,
            Math.sin(angle) * radius
          );
  
          mesh.lookAt(new THREE.Vector3(0, 0, 0));
          group.add(mesh);
  
          loadedCount++;
          if (loadedCount === totalImages) {
            scene.add(group);
            animate(); // Start animation only when all textures are ready
          }
        });
      });
  
      const ambientLight = new THREE.AmbientLight(0xffffff, 1);
      scene.add(ambientLight);
  
      const animate = () => {
        requestAnimationFrame(animate);
        group.rotation.y += 0.002; // Slower rotation
        renderer.render(scene, camera);
      };
  
      return () => {
        mountRef.current.removeChild(renderer.domElement);
      };
    }, []);
  
    return (
      <div
        ref={mountRef}
        style={{
          width: '100%',
          height: '600px',
          backgroundColor: '#000',
          borderRadius: '16px',
          overflow: 'hidden',
        }}
      />
    );
  };
  
  export default ThreeSlider;